module.exports = __webpack_public_path__ + "img/pdf-original-g201.74c29ff7.png";